export default __webpack_public_path__ + "static/media/Highlord's Spellsword.44d723b2.jpg";